import ProductCard from '@/entities/ProductCard/index.js'
import { ProductContent } from './ProductContent.jsx'

export const CatalogItems = ({ items, configRequest, productsInCart }, ref) => {
    return (
        <div className="CatalogItems goods-container">
            <h1>{configRequest.namePage}</h1>
            {!items || items.length === 0 ? (
                <div className="no-products">Нет доступных товаров</div>
            ) : (
                <div className="items">
                    {items.map((item) => (
                        <ProductCard
                            {...item}
                            key={item.product_id}
                            nameNode={
                                <h3 role="button" className={'title'}>
                                    {item.name}
                                </h3>
                            }
                        >
                            <ProductContent
                                item={item}
                                productsInCart={productsInCart}
                            />
                        </ProductCard>
                    ))}
                </div>
            )}
        </div>
    )
}
